import { accessRole } from "../../../../helpers/access_role"
import ErrorAccess from "../../../../components/Error/Content/Access"
import DetailPeriodComponent from "../Index/Components/DetailPeriodComponent"
import IndexPeriodComponent from "../Index/Components/IndexPeriodComponent"
import DetailPegawaiComponent from "../Detail/Components/DetailPegawaiComponent"

const RouteView = (props) => {

   const queryParams = new URLSearchParams(window.location.search);
   const section = queryParams.get('section');
   const uuid = queryParams.get('uuid');
   const currentRoleId = JSON.parse(localStorage.getItem("currentRoleId"));

   if(parseInt(currentRoleId) === 1){ // ADMIN
      if ((section !== undefined && section !== null) && (uuid !== undefined && uuid !== null)) {
         if (section === 'detail') {
            return <DetailPeriodComponent />
         } else if (section === 'assessment') {
            return <DetailPegawaiComponent />
         } else {
            return <ErrorAccess />
         }
      }
      return <IndexPeriodComponent />
   }else{
      return <ErrorAccess />
   }

   
}
export default RouteView